//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from "~/components/other/Button"
import {formatDate, getContentByCode, getItemByCode} from '~/utils/utils'
import Hint from '@/components/other/Hint'
import MtModalFull from '@/components/Modal/MtModalFull'
import MirMasterpiece from '@/components/forms/MirMasterpiece'
import MtModal from '@/components/Modal/MtModal'
import PriceList from '@/components/terms/PriceList'

export default {
  components: {
    PriceList,
    MtModal,
    MirMasterpiece,
    MtModalFull,
    Hint,
    Button
  },
  props: {
    currentMonthCost: {
      type: [String, Number],
      default: 0
    },
    accessMasterpieces: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      mirMasterpieceOpen: false,
      hint: null
    }
  },
  computed: {
    currentPage () {
      return this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1
    },
    btnMir () {
      if(this?.getTextBlocks?.data?.data) {
        return getItemByCode(this.getTextBlocks.data.data, 'kollektsiya-mir')?.btn1 || null
      } else {
        return null
      }
    }
  },
  methods: {
    openHint() {
      this.hint = true
    },
    openNextMasterpieces() {
      this.mirMasterpieceOpen = true
    },
    getMounth(latter, step = 0) {
      const lang = this.$i18n.locale !== 'en' ? 'ru' : 'en'
      let mounth = formatDate(new Date(), 'MMMM', step, lang)
      if (latter) {
        if (/[йь]/.test(mounth[mounth.length - 1])) {
          mounth = mounth.slice(0, mounth.length - 1) + latter
        } else if (this.$i18n.locale !== 'en') {
          mounth += latter === 'я' ? 'а' : latter
        }
      }
      return mounth
    },
    currentNumber(num) {
      if (!num) {
        return '0 ₽'
      }
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' ₽'
    },
    goToUrl(url) {
      if(url.includes('http')) {
        window.open(url, '_blank')
      } else {
        this.$router.push(url)
      }
    }
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'btn-mir',
        auto: true,
        params: {
          code: ['kollektsiya-mir'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
}
